import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Reply to a question
const GQLAddQuestionandReplies = gql`
  mutation createquestion_answer(
    $questionId: String
    $userId: String
    $neighborhoodId: String
    $message: String
    $postedDate: String
    $updatedDate: String
  ) {
    createquestion_answer(
      questionId: $questionId
      userId: $userId
      neighborhoodId: $neighborhoodId
      message: $message
      postedDate: $postedDate
      updatedDate: $updatedDate
    ) {
      success
      message
    }
  }
`;

// Saving the helpCount to the reply of a question.

const GQLHelpAnswer = gql`
  mutation helpanswer(
    $questionId: String
    $answerId: String
    $userId: String
    $neighborhoodId: String
    $helpStatus: Int
    $helpedDate: String
    $updatedDate: String
    $reviewuserId: String
  ) {
    helpanswer(
      questionId: $questionId
      answerId: $answerId
      userId: $userId
      neighborhoodId: $neighborhoodId
      helpStatus: $helpStatus
      helpedDate: $helpedDate
      updatedDate: $updatedDate
      reviewuserId: $reviewuserId
    ) {
      success
      message
    }
  }
`;

//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

// Add Reply to a question

async function addquestionandreplies(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddQuestionandReplies,
        variables: {
          questionId: adddata.questionId,
          userId: adddata.userId,
          neighborhoodId: adddata.neighborhoodId,
          message: adddata.message,
          postedDate: adddata.postedDate,
          updatedDate: adddata.updatedDate,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function helpanswer(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLHelpAnswer,
        variables: {
          questionId: adddata.questionId,
          answerId: adddata.answerId,
          userId: adddata.userId,
          helpContent: adddata.helpContent,
          helpStatus: adddata.helpStatus,
          neighborhoodId: adddata.neighborhoodId,
          helpedDate: adddata.helpedDate,
          updatedDate: adddata.updatedDate,
          reviewuserId: adddata.reviewuserId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export { addquestionandreplies, helpanswer };
